function t(e) {
  return (l) => {
    l ? e.value = l.$el : e.value = null;
  };
}
export {
  t as createRefSetter
};
